import { render, staticRenderFns } from "./DistrictSelection.vue?vue&type=template&id=4b966472"
import script from "./DistrictSelection.vue?vue&type=script&lang=js"
export * from "./DistrictSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports